<div
  [viewportOptions]="{
    verticalTolerance: 200,
    horizontalTolerance: 10,
    shouldCheckHorizontal: false
  }"
  (visibilityChange)="onVisibilityChange($event)"
  class="search-results"
  astrobinScrollVisibility
>
  <ng-container *ngIf="!initialLoading; else loadingTemplate">
    <ng-container *ngIf="results !== null; else loadingTemplate">
      <ng-container *ngIf="results.length > 0; else noResultsTemplate">
        <div *ngFor="let comment of results" (click)="openComment(comment)" class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <img
              *ngIf="comment.imageThumbnail"
              [alt]="comment.contentObjectTitle"
              [src]="comment.imageThumbnail"
              class="image-thumbnail"
            />
            <div class="flex-grow-1">
              <h4>{{ comment.contentObjectTitle }}</h4>
              <small>
                <span class="username">{{ comment.userDisplayName }}</span>
                &middot;
                <span class="created">{{ comment.created | localDate | timeago }}</span>
              </small>
            </div>
            <img
              *ngIf="comment.userAvatar"
              [alt]="comment.userDisplayName"
              [src]="comment.userAvatar"
              class="user-avatar"
            />
          </div>

          <div
            *ngIf="comment.text | BBCodeToHtml | async as html; else commentTextLoading"
            [innerHTML]="html | removeBr | highlight: model.text?.value"
            class="card-body"
          ></div>
          <ng-template #commentTextLoading>
            <div class="card-body">
              <small><fa-icon animation="spin" icon="spinner"></fa-icon> {{ "Loading content..." | translate }}</small>
            </div>
          </ng-template>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <div *ngIf="loading && !initialLoading" class="loading">
    <ng-container [ngTemplateOutlet]="loadingTemplate"></ng-container>
  </div>
</div>

<ng-template #noResultsTemplate>
  <astrobin-nothing-here [withAlert]="false" [withInfoSign]="false"></astrobin-nothing-here>
</ng-template>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
